module.exports = __webpack_public_path__ + "img/sld_abt_dark.abfa108b.svg";